(ns kyber.styles.colors
  (:require [kyber.constants :refer [partner-color]]
            [kyber.utils :as u]))

(def midnight-blue
  {"50"  "#f3f4f6"
   "100" "#e6e9ed"
   "200" "#ced4dc"
   "300" "#9da9b9"
   "400" "#6d7d95"
   "500" "#415370"
   "600" "#0b274f"
   "700" "#091f3f"
   "800" "#07172f"
   "900" "#041020"})

(def steel-blue
  {"50"  "#f2f8fc"
   "100" "#e5f1f8"
   "200" "#cce3f2"
   "300" "#99c6e4"
   "400" "#66aad7"
   "500" "#338dc9"
   "600" "#0071bc"
   "700" "#005a96"
   "800" "#004471"
   "900" "#002d4b"})

(def orange
  {"50"  "#fffaf5"
   "100" "#fff5ea"
   "200" "#ffebd6"
   "300" "#ffd6ad"
   "400" "#ffc285"
   "500" "#ffad5c"
   "600" "#ff9933"
   "700" "#cc7a29"
   "800" "#995c1f"
   "900" "#663d14"})

(def green
  {"50"  "#f7faf3"
   "100" "#eff6e7"
   "200" "#e0edcf"
   "300" "#c1db9f"
   "400" "#a2c96f"
   "500" "#83b73f"
   "600" "#64a50f"
   "700" "#50840c"
   "800" "#3c6309"
   "900" "#284206"})

(def gray-scale
  {"50" "#fbfbfb"
   "100" "#f4f4f4"
   "200" "#eaeaea"
   "300" "#cbcbcb"
   "400" "#979797"
   "500" "#636363"
   "600" "#2f2f2f"
   "700" "#272727"
   "800" "#1f1f1f"})

(def red
  {"50" "#ffebee"
   "100" "#ffcdd2"
   "200" "#ef9a9a"
   "300" "#e57373"
   "400" "#ef5350"
   "500" "#f44336"
   "600" "#e53935"
   "700" "#d32f2f"
   "800" "#c62828"
   "900" "#b71c1c"})

(def true-color
  {"white" "#ffffff"
   "black" "#000000"})

(def success "#83b73f")
(def error "#f44336")
(def warning "#f69533")

(def info-colors
  {:info-100 "#ebf2f4"
   :info-200 "#b5d5e9"})

(def highlight-colors
  {:highlight-50 "rgba(255,218,44,0.15)"})

(def theme-colors
  {:primary "#6d7d95"})

(def chart
  {"red" "#c55142"
   "orange" "#f29d4b"
   "green" "#74ad53"})

(def system-theme-colors
  {"admin" "#caedec"})

(def colors
  (reduce (fn [acc [color-map color-name]]
            (let [updated-map
                  (reduce (fn [acc [color-level color-value]]
                            (assoc acc
                                   (keyword (str color-name "-" color-level))
                                   color-value))
                          {}
                          color-map)]
              (merge acc updated-map)))
          (merge info-colors highlight-colors)
          [[(u/generate-color-palette partner-color) "primary-lite"]
           [(u/generate-grayscale-palette partner-color) "primary-gray"]
           [(u/generate-color-palette error) "error"]
           [(u/generate-color-palette warning) "warning"]
           [(u/generate-color-palette success) "success"]
           [orange "secondary-one"]
           [green "secondary-two"]
           [green "green"]
           [red "red"]
           [orange "orange"]
           [gray-scale "gray-scale"]
           [true-color "true"]
           [chart "chart"]
           [system-theme-colors "system-theme"]]))
